import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { CreditCardFeatureFilterOptionsValues, CreditCardFilterTypes, LoanFilterTypes } from 'embed/constants'
import { getContrastingColor } from 'embed/utils'
import { css } from 'emotion'
import * as React from 'react'
const styles = require('./styles.scss')

export interface ButtonToggle {
  active?: boolean
  className?: string
  iconUrl?: string
  label: string
  value: string | CreditCardFeatureFilterOptionsValues
  filterCategory: CreditCardFilterTypes | LoanFilterTypes
}

export interface ButtonToggleProps {
  badge: ButtonToggle
  className?: string
  onClick?: (badge: ButtonToggle) => void
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ButtonToggle = (props: ButtonToggleProps) => {
  const {
    badge,
    badge: { active, label, value },
    className,
    onClick,
  } = props
  const handleClick = () => onClick?.(badge)

  return (
    <ThemeConsumer>
      {({ borderRadiusLarge, colorBackgroundPrimary, colorPrimary, fontFamilyPrimary }) => (
        <label
          key={value}
          onClick={handleClick}
          className={classnames(
            className,
            styles.toggle,
            css(`
        background: ${colorBackgroundPrimary};
        border-radius: ${borderRadiusLarge};
        border-color: ${colorPrimary};
        color: ${colorPrimary};
        font-family: ${fontFamilyPrimary};
      `),
            {
              [css(`
        background: ${colorPrimary};
        border-radius: ${borderRadiusLarge};
        border-color: ${colorPrimary};
        color: ${getContrastingColor(colorPrimary)};
        font-family: ${fontFamilyPrimary};
    `)]: active,
            },
          )}
          htmlFor={value}
        >
          <div className={classnames(styles.rowContainer)}>
            {badge.iconUrl && (
              <div data-test-class="icon" className={classnames(styles.icon)}>
                <img src={badge.iconUrl} />
              </div>
            )}
            <p>{badge.label}</p>
          </div>
          <input name={label} value={value} defaultChecked={active} className={styles.checkbox} type="checkbox" />
        </label>
      )}
    </ThemeConsumer>
  )
}
